import React from 'react';
import { Card, Row, Col, Typography, Space, Tag, Image, Button } from 'antd';
import { ClockCircleOutlined, EnvironmentOutlined, EditOutlined } from '@ant-design/icons';
import moment from 'moment';

const { Text } = Typography;

const EventCard = ({ event, className = '', style = {} }) => {
  
  // Extract data from the API structure
  const eventData = event.publicationData || event;
  
  // Debug logging
  console.log('🎫 [EventCard] Event data:', eventData);
  const title = eventData.title || 'Untitled Event';
  const eventType = Array.isArray(eventData.eventType) 
    ? (eventData.eventType[0]?.value || eventData.eventType[0] || 'Event')
    : (eventData.eventType?.value || eventData.eventType || 'Event');
  const startTime = eventData.startTime;
  const endTime = eventData.endTime;
  const organisationName = eventData.organisationName;
  const localisation = eventData.localisation;
  const flyer = eventData.flyer;
  const description = eventData.description;
  
  // Extract city and country from localisation or event data
  const cityName = eventData.city?.value || eventData.city || localisation?.city?.value || localisation?.city || 'Unknown City';
  const countryName = eventData.country?.value || eventData.country || localisation?.country?.value || localisation?.country || 'Unknown Country';
  const address = localisation?.address || eventData.address || '';

  // Handle edit button click - opens in new tab
  const handleEditClick = () => {
    console.log('✏️ [EventCard] Edit button clicked for event:', event._id);
    window.open(`/detail-publication/${event._id}?publicationType=Event`, '_blank');
  };

  return (
    <Card 
      size="small" 
      className={`mb-2 hover:shadow-md transition-shadow ${className}`}
      style={{ borderLeft: '4px solid #1890ff', ...style }}
      actions={[
        <Button
          key="edit"
          type="primary"
          size="small"
          icon={<EditOutlined />}
          onClick={handleEditClick}
          className="flex items-center"
        >
          Edit Event
        </Button>
      ]}
    >
      <Row gutter={[12, 8]}>
        {/* Event Image */}
        {flyer && (
          <Col span={6}>
            <Image
              src={flyer}
              alt={title}
              width="100%"
              height={80}
              className="rounded object-cover"
              preview={false}
              style={{ objectFit: 'cover' }}
            />
          </Col>
        )}
        
        {/* Event Details */}
        <Col span={flyer ? 18 : 24}>
          <div className="flex justify-between items-start mb-2">
            <Text strong className="text-base">{title}</Text>
            <Tag color="blue" className="text-xs">
              {String(eventType)}
            </Tag>
          </div>
          
          <Space direction="vertical" size="small" className="w-full">
            <Space size="small" className="text-sm text-gray-600">
              <ClockCircleOutlined />
              <Text className="text-sm">
                {moment(startTime).format('MMM DD, YYYY HH:mm')}
                {endTime && ` - ${moment(endTime).format('HH:mm')}`}
              </Text>
            </Space>
            
            <Space size="small" className="text-sm text-gray-600">
              <EnvironmentOutlined />
              <Text className="text-sm">
                {String(cityName)}{countryName && `, ${String(countryName)}`}
              </Text>
            </Space>
            
            {organisationName && (
              <Text className="text-sm text-gray-500">
                🏢 {organisationName}
              </Text>
            )}
            
            {address && (
              <Text className="text-sm text-gray-500" ellipsis>
                📍 {address}
              </Text>
            )}
            
            {description && (
              <Text className="text-sm text-gray-600" ellipsis={{ rows: 2 }}>
                {description}
              </Text>
            )}
          </Space>
        </Col>
      </Row>
    </Card>
  );
};

export default EventCard; 